import { useMutation } from '@th/react-query';
import AxiosClient from '@th/frontend-shared/src/utils/AxiosClient';
import { AxiosError } from 'axios';
import logAxiosError from '@th/frontend-shared/src/utils/logAxiosError';
import { useRef } from 'react';

type Options = {
  onSuccess?: () => void;
  onError?: (err: AxiosError) => void;
  preventMultipleCalls?: boolean;
};

export default function useDeleteWatchedSearch(options?: Options) {
  const hasFiredRef = useRef(false);

  const { mutate, mutateAsync, isLoading, isSuccess } = useMutation(
    async (id: string) => {
      try {
        if (options?.preventMultipleCalls && hasFiredRef.current) return;

        hasFiredRef.current = true;
        await AxiosClient.delete(`/api/v2/watched/searches/${id}`);
      } catch (err) {
        // This try/catch is an unusual pattern for us.
        // Normally we'd use react-query's built-in onError, but in this case I was finding that in dev mode,
        //   NextJs would throw an aggressive error popup modal while testing some handled error conditions
        if (options?.onError) {
          options.onError(err);
        } else {
          logAxiosError('useDeleteWatchedSearch', err);
        }
      }
    },
    {
      onSuccess: () => {
        if (options?.onSuccess) {
          options.onSuccess();
        }
      },
    },
  );

  return { mutate, mutateAsync, isLoading, isSuccess };
}
